import {useState} from "react";
import plusIcon from "@/assets/icons/interface/plus.svg";
import {Text} from "@/elements/text";
import type {SectionQuestionAnswer} from "@/generated/api";
import {AnswerWrapper, Container, PlusIcon, TextWrapper, TitleWrapper} from "./styles.js";

// The card turns over by a CSS transition. It was a spring of framer-motion (stiffness 300, damping 80: no bounce, a long tail); this curve is fitted on its
// trajectory measured in Chromium (angle against time, within 1 % of it)
const FLIP = "transform 1.6s cubic-bezier(0.15, 0.95, 0.35, 1)";
const flip = (angle: number) => ({
  transform: `rotateY(${angle}deg)`,
  transition: FLIP,
});

interface QuestionCardProps {
  cardData: SectionQuestionAnswer["questions"][number];
}

const QuestionCard = ({cardData}: QuestionCardProps) => {
  const {emoji, title, question, answer} = cardData;

  const [isFlipped, setIsFlipped] = useState(false);

  const handleClick = () => {
    setIsFlipped((prevState) => !prevState);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        perspective: "1200px",
        transformStyle: "preserve-3d",
        width: "100%",
        display: "flex",
        height: "auto",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            perspective: "1200px",
            transformStyle: "preserve-3d",
            width: "100%",
            height: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              zIndex: isFlipped ? 0 : 1,
              backfaceVisibility: "hidden",
              position: "absolute",
              ...flip(isFlipped ? -180 : 0),
            }}
          >
            <Container isCardOpen={false}>
              <TextWrapper>
                <TitleWrapper>
                  <Text type="textLarge" style={{fontWeight: "bold"}}>
                    {emoji}
                  </Text>
                  <Text type="textLarge" style={{fontWeight: "bold"}}>
                    {title}
                  </Text>
                </TitleWrapper>
                <Text type="textLarge">{question}</Text>
                <PlusIcon src={plusIcon} alt="" isCardOpen={false} />
              </TextWrapper>
            </Container>
          </div>
          <div
            style={{
              width: "100%",
              height: "100%",
              zIndex: isFlipped ? 1 : 0,
              backfaceVisibility: "hidden",
              ...flip(isFlipped ? 0 : 180),
            }}
          >
            <Container isCardOpen={true}>
              <TextWrapper>
                <TitleWrapper>
                  <Text type="textLarge" style={{fontWeight: "bold"}}>
                    {emoji}
                  </Text>
                  <Text type="textLarge" style={{fontWeight: "bold"}}>
                    {title}
                  </Text>
                </TitleWrapper>
                <AnswerWrapper
                  maxHeightValue={(answer ? answer.length : 0) + 20}
                  isCardOpen={isFlipped}
                >
                  <Text
                    type="textLarge"
                    style={{
                      fontSize: "1rem",
                      lineHeight: "22px",
                      fontWeight: "bold",
                      paddingBottom: 20,
                    }}
                  >
                    {answer?.trim()}
                  </Text>
                </AnswerWrapper>
                <PlusIcon src={plusIcon} alt="" isCardOpen={true} />
              </TextWrapper>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuestionCard;
